/* eslint-disable react/prop-types */
import { Container, Lista } from './Step.style';
import React from 'react';
const Step = ({ items }) => {
  const getStepClass = (currentIndex, currentValue) => {
    if (!currentValue[1]) return '';

    const nextFalseIndex = items.findIndex((item, index) => index > currentIndex && !item[1]);

    if (nextFalseIndex !== -1 && currentIndex === nextFalseIndex - 1) {
      return 'loading';
    }

    return 'check';
  };

  return (
    <Container>
      <Lista className="step">
        {items.map((item, index) => (
          <li className={getStepClass(index, item)} key={index}>
            {item[0]}
          </li>
        ))}
      </Lista>
    </Container>
  );
};

export default Step;
